<div class="m-t20"></div>

<highcharts-chart  *ngIf="isDataAvailable"
    [Highcharts] = "Highcharts"
    [options]="options"   
    class="flex-row-center"   
    style="width: 100%;display: block;">
</highcharts-chart>        
<div  *ngIf="!isDataAvailable" class="flex-col-center m-t75">     
    <!-- <div  class="m-t25 chartLoading">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
    <div class="bar4"></div>
    <div class="bar5"></div>
    <div class="bar6"></div>
    </div> -->
    <gp-chart-loading-animation></gp-chart-loading-animation>
</div>



<!-- <highcharts-chart  
    [Highcharts] = "Highcharts"
    [options]="options"  
    [callbackFunction]="chartCallBack" 
    style="width: 100%; height: 95%; display: block;">
</highcharts-chart>             -->

